import createReducer from '../createReducer'
import { getMapMarkers, updateMapMarkers, getPageLinks } from './helpers'
import { parseLocationSuggestions } from '../shared/helpers'

import {
  FETCH_ROUTE_SUCCESS,
  FETCH_ROUTE_ERROR,
  SEARCH_ROUTES_LOADING,
  SEARCH_ROUTES_SUCCESS,
  GET_LOCATION_SUGGESTIONS_SUCCESS,
  SELECT_ROUTE,
  CHECK_FOR_MAPS_SCRIPT_SUCCESS,
  LOAD_USER_ROUTES_SUCCESS,
} from './constants'

export const initialState = {
  route: null,
  directions: null,
  googleMapsLoaded: false,
  searchLoading: false,
  searchResults: [],
  searchResultsCount: 0,
  formattedUserCoords: null,
  searchCoords: {
    lat: 37.09024,
    lng: -95.71289100000001,
  },
  selectedRouteId: null,
  noRoutesFound: false,
  mapMarkers: [],
  nextRoutesLink: null,
  prevRoutesLink: null,
  userRoutes: [],
  noUserRoutesFound: false,
}

export default createReducer(initialState, {

  [LOAD_USER_ROUTES_SUCCESS]: (state, action) => {
    const userRoutes = action.payload.data._embedded.routes
    return {
      ...state,
      userRoutes: userRoutes,
      noUserRoutesFound: (userRoutes.length === 0),
    }
  },

  [FETCH_ROUTE_SUCCESS]: (state, action) => {
    const { payload: { data: route }} = action
    return { ...state, route }
  },

  [FETCH_ROUTE_ERROR]: (state) => {
    // @TODO
    return { ...state }
  },

  [CHECK_FOR_MAPS_SCRIPT_SUCCESS]: (state) => {
    return { ...state, googleMapsLoaded: true }
  },

  [SEARCH_ROUTES_LOADING]: (state) => {
    return {
      ...state,
      noRoutesFound: false,
      searchLoading: true,
      selectedRouteId: null,
    }
  },

  [SEARCH_ROUTES_SUCCESS]: (state, action) => {
    const { payload: { data: { _embedded: { routes }}}} = action
    const { payload: { data: { total_count }}} = action
    let searchCoords = state.searchCoords

    if (action.meta.searchCoords) {
      const searchLatLng = action.meta.searchCoords.split(',')
      searchCoords = {
        lat: parseFloat(searchLatLng[0]),
        lng: parseFloat(searchLatLng[1]),
      }
    }

    /* eslint camelcase: 0 */
    const noRoutesFound = total_count === 0
    const mapMarkers = getMapMarkers(routes)
    const pageLinks = getPageLinks(action.payload.data._links)

    return {
      ...state,
      searchResults: routes,
      searchResultsCount: total_count,
      noRoutesFound: noRoutesFound,
      searchLoading: false,
      mapMarkers: mapMarkers,
      searchCoords: searchCoords,
      nextRoutesLink: pageLinks.next,
      prevRoutesLink: pageLinks.prev,
    }
  },

  [GET_LOCATION_SUGGESTIONS_SUCCESS]: (state, action) => {
    const { payload } = action
    let formattedUserCoords = state.formattedUserCoords
    let searchCoords = state.searchCoords
    const locationSuggestions = parseLocationSuggestions(payload)

    if (action.meta.setUserCoords && locationSuggestions.length) {
      const userCoords = locationSuggestions[0].value
      formattedUserCoords = userCoords
      const userLatLng = userCoords.split(',')
      searchCoords = {
        lat: parseFloat(userLatLng[0]),
        lng: parseFloat(userLatLng[1]),
      }
    }

    return {
      ...state,
      formattedUserCoords: formattedUserCoords,
      searchCoords: searchCoords,
    }
  },

  [SELECT_ROUTE]: (state, action) => {
    const updatedMarkers = updateMapMarkers(state.mapMarkers, action.selectedRouteId)

    return {
      ...state,
      selectedRouteId: action.selectedRouteId,
      mapMarkers: updatedMarkers,
    }
  },
})
